"use client";
import { useEffect } from 'react';
import { trackVisitor } from '../actions/visitors';

// Hook to track page visits
export function useVisitorTracking(pageName: string) {
  useEffect(() => {
    const trackPageVisit = async () => {
      try {
        // Get client IP (we'll need to call an API for this)
        const ipResponse = await fetch('/api/get-ip');
        const { ip } = await ipResponse.json();
        
        // Generate session ID if not exists
        let sessionId = sessionStorage.getItem('sessionId');
        if (!sessionId) {
          sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          sessionStorage.setItem('sessionId', sessionId);
        }
        
        // Track the visit
        await trackVisitor({
          ipAddress: ip,
          userAgent: navigator.userAgent,
          page: pageName,
          referrer: document.referrer || undefined,
          sessionId
        });
      } catch (error) {
        console.error('Error tracking visitor:', error);
      }
    };
    
    trackPageVisit();
  }, [pageName]);
}

// Component for tracking visitors
export function VisitorTracker({ pageName }: { pageName: string }) {
  useVisitorTracking(pageName);
  return null;
}
